import React, { useState } from 'react';
import { useLocale } from '../../../localization/LocaleProvider';

const PulseTemplatePreviewPages = ({ values, display }) => {
    const [showAssessment, setShowAssessment] = useState(true);
    const [sliderValue, setSliderValue] = useState(1);
    const { translate } = useLocale();

    if(display == -2) { //Startskrärm, "Välkommen till vår anonyma undersökning"
      return (
        <div style={{paddingLeft: "16px", paddingRight: "16px"}}>
          <p style={{fontWeight: "bold", fontSize: "28px", lineHeight: "21px", margin: 0, marginBottom: "5px"}}>{translate("Rolf Pulse")}</p>
          <p style={{fontSize: "14px", margin: "14px 0 14px 0"}}>{translate("Welcome to our anonymous survey.")}</p>
          <p style={{fontSize: "14px", margin: "14px 0 14px 0"}}>{translate("Your responses are confidential, and no personally identifiable information is being collected.")}</p>
          <p style={{fontSize: "14px", margin: "14px 0 14px 0"}}>{translate("If you have any questions or concerns about the anonymity of this survey, please feel free to reach out to us at info@rolf.se")}</p>
        </div>
      )
    }

    if(display == -1) { //Rubrik, mallbeskrivning
      return (
        <div style={{paddingLeft: "16px", paddingRight: "16px"}}>
          <p style={{fontWeight: "bold", fontSize: "21px", lineHeight: "22.5px", margin: "17px 0 17px 0"}}>{values.name || ""}</p>
          <p style={{fontSize: "14px", margin: "14px 0 14px 0"}}>{values.description || ""}</p>
        </div>
      )
    }

    if(display == values.properties.length) { //Slutskärm
      return (
        <div style={{paddingLeft: "16px", paddingRight: "16px"}}>
          <p style={{fontWeight: "bold", fontSize: "16.5px", lineHeight: "21px", margin: "16px", marginLeft: 0 }}>{translate("Finish")}</p>
          <p style={{fontSize: "14px", margin: "14px 0 14px 0"}}>{translate("Before submitting your responses, you have the opportunity to share your thoughts related to this survey. You can leave the field blank.")}</p>
          <p style={{fontSize: "14px", margin: "14px 0 14px 0"}}>{translate("When you are satisfied with your responses and want to complete the survey, click \"Submit response\".")}</p>
          <div style={{width: "100%", marginBottom: "12px"}}>
            <p style={{fontWeight: "bold", fontSize: "11.2px", lineHeight: "21px", marginBottom: "6px", marginTop: "0px", textTransform: "uppercase" }}>{translate("Other comments you want to share (optional)")}</p>
            <textarea rows={4} style={{borderRadius: "6px", height: "70px", color: "#000000", backgroundColor: "#ebebeb", paddingRight: "16px", width: "100%", marginRight: "16px"}} placeholder={values.feedbackDescription || ""}></textarea>
          </div>
        </div>
      )
    }

      return values.properties.sort((a,b) => {
        if(a.sortOrder > b.sortOrder) return 1;
        if(a.sortOrder < b.sortOrder) return -1;
        if(a.sortOrder == b.sortOrder) return 0;
      }).map((property, index) => {
      return (
        <>
          <p style={{fontWeight: "bold", fontSize: "16.5px", lineHeight: "21px", margin: "16px" }}>{property.name}</p>
          <p style={{fontSize: "14px", lineHeight: "21px", margin: "16px", whiteSpace: "pre-wrap" }}>{property.description}</p>
        
          { showAssessment ? 
          /* Visa scaleLabels om de finns */
          Array.isArray(property.scaleLabels) && property.scaleLabels.length > 0 ?
          <>
            <div className="flex" style={{justifyContent: "space-around", paddingLeft: "16px", paddingRight: "16px"}}>
              {property.scaleLabels.map((label, index) => {
                return (
                  <div key={index} style={{display: "flex", width: "100%", marginBottom: "21px"}} >
                    <span style={{ width: "100%", textAlign: "center", fontSize: "10px", padding: "0.5rem", backgroundColor: "#ebebeb", padding: "7px"}}>{label.title}</span>
                  </div>
                )
              }
              )}
            </div>
          </>
          : values.rolfingScale == 2 ?
          <>
            <div className="flex" style={{justifyContent: "space-around", paddingLeft: "16px", paddingRight: "16px"}}>
              {values.scaleLabels.map((label, index) => {
                return (
                  <div key={index} style={{display: "flex", width: "100%", marginBottom: "21px"}} >
                    <span style={{ width: "100%", textAlign: "center", fontSize: "10px", padding: "0.5rem", backgroundColor: "#ebebeb", padding: "7px"}}>{label.title}</span>
                  </div>
                )
              })}

            </div>

            </>
            : 
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: "21px", marginLeft: "16px", marginRight: "16px" }}>
              {
                [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item, index) => {
                  return (
                    <div key={index} style={{backgroundColor: "rgb(234, 234, 234)", width: "30px", height: "30px", borderRadius: "24px", textAlign: "center", paddingTop: 4}}>
                      <span style={{fontSize: "12px", color: "rgb(102,102,102)"}}>{item}</span>
                    </div>
                  )
                })
              }
            </div>
            : null
          }    
          
          <div style={{width: "100%", paddingLeft: "16px", paddingRight: "16px", marginBottom: "12px"}}>
            <p style={{fontWeight: "bold", fontSize: "11.2px", lineHeight: "21px", marginBottom: "6px", marginTop: "0px", textTransform: "uppercase" }}>{translate("Comment (optional)")}</p>
            <textarea rows={4} placeholder={property.customPlaceholders ? property.customPlaceholders : ""} style={{borderRadius: "6px", height: "70px", color: "#000000", backgroundColor: "#ebebeb", paddingRight: "16px", width: "100%", marginRight: "16px"}}></textarea>
          </div>
        </>
      )
    }).filter((item, index) => index == display);
  }
  

  export default PulseTemplatePreviewPages;